function contemUmaLetraValida(nome, letras) {
    if (nome.length === 1) {
        let validacaoNome = false;

        for (let index = 0; index < letras.length; index += 1) {
            const element = letras[index];
            validacaoNome = nome.toLowerCase().includes(element) || validacaoNome;
        }

        return validacaoNome;
    }
    return true;
}

function contemSobrenome(nome) {
    const nomeCompleto = nome.split(' ');
    return nomeCompleto.length >= 2;
}

function contemNumero(nome) {
    return /[0-9]/.test(nome);
}

function contemMultiploEspacoEmBranco(nome) {
    return /[\s]{2}/.test(nome.toString().trim());
}

function contemCaracterEspecial(nome) {
    return /[!-/:-@[-`{-~]+/.test(nome);
}

function contemNomeValido(nome) {
    const nomeCompleto = nome.split(' ');
    const primeiroNome = nomeCompleto[0];
    const letras = ['d', 'o', 'ó', 'ò', 'ô', 'õ', 'ö', 'y', 'ý', 'ÿ', 'u', 'ú', 'ù', 'û', 'ü', 'i', 'í', 'ì', 'î', 'ï'];

    return contemUmaLetraValida(primeiroNome, letras);
}

function contemSobrenomeValido(nome) {
    const nomeCompleto = nome.split(' ');
    const ultimoSobrenome = nomeCompleto[nomeCompleto.length - 1];
    const letras = ['o', 'ó', 'ò', 'ô', 'õ', 'ö', 'y', 'ý', 'ÿ', 'u', 'ú', 'ù', 'û', 'ü', 'i', 'í', 'ì', 'î', 'ï'];

    return contemUmaLetraValida(ultimoSobrenome, letras);
}

function contemNomeEY(nome) {
    const nomes = nome.split(' ');

    nomes.pop();
    nomes.shift();

    // return nomes.includes('e') || nomes.includes('E') || nomes.includes('Y') || nomes.includes('y');
    return nomes.includes('Y') || nomes.includes('y');
}

export function validaNome(nome) {
    const errors = [];

    if (nome) {
        if (!contemSobrenome(nome)) {
            errors.push('Adicione um nome e sobrenome.');
        }

        if (contemNumero(nome)) {
            errors.push('');
        }

        if (!contemNomeValido(nome)) {
            errors.push('O primeiro nome deve ter mais de uma letra.');
        }

        if (!contemSobrenomeValido(nome)) {
            errors.push('O último nome deve ter mais de uma letra.');
        }

        if (contemCaracterEspecial(nome)) {
            errors.push('Apenas acentuação é aceita como caractere especial.');
        }

        if (contemNomeEY(nome)) {
            errors.push(
                'Entre o nome e sobrenome deve ser evitado o uso de Y (ex: João da Silva y Santos).'
            );
        }

        if (contemMultiploEspacoEmBranco(nome)) {
            errors.push('Excesso de espaço entre nome e sobrenome.');
        }
    }

    return errors;
}
